
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IuC5hOC4oeC5iOC4quC4suC4oeC4suC4o%2BC4luC4o%2BC4sOC4muC4uDoge21hdGNoZXN9In0%3D!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IuC5hOC4oeC5iOC4quC4suC4oeC4suC4o%2BC4luC4o%2BC4sOC4muC4uDoge21hdGNoZXN9In0%3D!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlRpZGFrIGRhcGF0IG1lbmdhbmR1bmc6IHttYXRjaGVzfSJ9!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlRpZGFrIGRhcGF0IG1lbmdhbmR1bmc6IHttYXRjaGVzfSJ9!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IuC5hOC4oeC5iOC4quC4suC4oeC4suC4o%2BC4luC4o%2BC4sOC4muC4uDoge21hdGNoZXN9In0%3D!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IuC5hOC4oeC5iOC4quC4suC4oeC4suC4o%2BC4luC4o%2BC4sOC4muC4uDoge21hdGNoZXN9In0%3D!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlRpZGFrIGRhcGF0IG1lbmdhbmR1bmc6IHttYXRjaGVzfSJ9!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlRpZGFrIGRhcGF0IG1lbmdhbmR1bmc6IHttYXRjaGVzfSJ9!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ%3D%3D!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlvDh8SDxIPEg%2BC4geC4teC5ieC4geC4teC5icO2w7bDtuG5ryDDp8O2w7bDtuC4geC4teC5ieG5r8SDxIPEg8Osw6zDrOC4geC4teC5iToge21hdGNoZXN9XSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlvDh8SDxIPEg%2BC4geC4teC5ieC4geC4teC5icO2w7bDtuG5ryDDp8O2w7bDtuC4geC4teC5ieG5r8SDxIPEg8Osw6zDrOC4geC4teC5iToge21hdGNoZXN9XSJ9!"
        )
      )
      });
  
      export { translations as default };
    